module.exports = __webpack_public_path__ + "static/media/cchc.341d0474.svg";